// Enkel Toggle-komponent
interface ToggleProps {
    label: string;
    checked: boolean;
    onChange: () => void;
    bordering: boolean,
    insideLabel: string,
}
export function Toggle({ label, checked, onChange, bordering = true, insideLabel }: ToggleProps) {
    return (
        <div className={bordering ? "flex items-center justify-between bg-gray-50 p-3 rounded-xl border border-gray-200 shadow-sm" : ""}>
            <span className="font-medium text-gray-700">{label}</span>
            <div
                onClick={onChange}
                className={`relative w-16 h-8 flex items-center rounded-full cursor-pointer transition-colors duration-300 ${(insideLabel === "ReceivingCallSwitch" ? (checked ? "bg-green-500" : "bg-yellow-300") : (checked ? "bg-green-500" : "bg-gray-300"))
                    }`}
            >
                <span
                    className={`absolute ${insideLabel === "ReceivingCallSwitch" ? 'w-4 h-4' : 'w-6 h-6'} bg-white rounded-full shadow-md transform transition-transform duration-300 ${(insideLabel === "ReceivingCallSwitch" ? (checked ? "translate-x-11" : "translate-x-1") : (checked ? "translate-x-8" : "translate-x-1")) 
                        }`}
                />
                <span
                    className={`absolute text-xs font-semibold ${checked
                        ? "text-white left-2"
                        : "text-gray-700 right-2"
                        }`}
                >
                    {insideLabel === "OnOffSwitch"
                        ? checked ? "On" : "Off"
                        : insideLabel === "ReceivingCallSwitch"
                            ? checked ? "Phone" : "Web"
                            : checked ? "On" : "Off"
                    }
                </span>
            </div>
        </div>
    );
}